import React from 'react';
import '../style/formGroupTextInput.css'
import FromGroupTableRow from './formGroupTableRow';
import FromGroupPlainTableRow from './formGroupPlainTableRow';
import '../style/formGroupTableRow.css'

const FormGroupTable = (props) => {
    return (
        <div className="form-group formGroup-noBottomMargin">
                <div className={props.LeftWrapper}>
                    <label className={"control-label.text-left formGroup-textInput-label" + (props.labelAsALink ? " formGroup--link-label" : "")}>
                        {props.Label}
                        {props.Required?
                            <span>{' '}*</span>
                            :
                            null
                        }
                    </label>
                </div>
                <div className={props.centerWrapper}>
                </div>
                <div className={props.rightWrapper}>
                    {props.rightData ? props.rightData : null}
                </div>
                <div className={'col-sm-12'}>
                    <div>
                        <table className="table table-striped agents-list-table">
                            <thead className="agents-list-table-head">
                            <tr className="agents-list-table-column">
                                <th className="col-sm-2" key="name">Name</th>
                                <th className=" col-sm-2" key="natureOfExpert">Nature of Expert</th>
                                <th className=" col-sm-2" key="whySpecificExpert">Why Specific Expert?</th>
                                <th className=" col-sm-2" key="breachCausationCpId">Breach/Causation/CP</th>
                                <th className=" col-sm-2" key="partialEstimatedCost">Estimated Cost of Report</th>
                                <th className=" col-sm-2" key="attendanceEstimatedCost">Estimated Cost of Attendance at Final Hearing</th>
                            </tr>
                            </thead>
                            <tbody className="appFormRefSettings-tbody">
                            {
                                props.medicalExpertFees.map((fee, index) => {
                                    if (props.plain)
                                        return <FromGroupPlainTableRow
                                            onInfoClick={props.onInfoClick}
                                            checkIfRowHasBeenModified={props.checkIfRowHasBeenModified}
                                            changesRequriesARAGApproval={props.changesRequriesARAGApproval}
                                            editingSetting={props.editingSetting}
                                            onDeleteRowClick={props.onDeleteRowClick}
                                            totalRows={props.medicalExpertFees.length}
                                            onEditRowClick={props.onEditRowClick}
                                            areRowsEditable={props.areRowsEditable}
                                            key={index} index={index} Data={fee}
                                            breachCausationCp={props.breachCausationCp}/>
                                    return <FromGroupTableRow
                                        removeMedicalExpertFeesTableRow={props.removeMedicalExpertFeesTableRow}
                                        data={fee}
                                        key={index} index={index} Data={null}
                                        updateMedicalExpertFees={props.updateMedicalExpertFees}
                                        breachCausationCp={props.breachCausationCp}/>
                                })
                            }

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
    )
};

export default FormGroupTable;